import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#date-and-time" }),
  /*#__PURE__*/_createTextVNode(" Date and time ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = { class: "block mb-5" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Default", -1)
const _hoisted_6 = { class: "block mb-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "With shortcuts", -1)
const _hoisted_8 = { class: "block" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "With default time", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.value1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value1 = $event)),
          type: "datetime",
          placeholder: "Select date and time"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.value2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value2 = $event)),
          type: "datetime",
          placeholder: "Select date and time",
          shortcuts: _ctx.shortcuts
        }, null, 8, ["modelValue", "shortcuts"])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.value3,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.value3 = $event)),
          type: "datetime",
          placeholder: "Select date and time",
          "default-time": _ctx.defaultTime
        }, null, 8, ["modelValue", "default-time"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
}